import React, { useState, useEffect } from 'react';
import './SliderComponent.css'; // We'll create this CSS file
import { useNavigate } from 'react-router';

const SliderComponent = ({ sliderData, onSlidePress }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  // Auto-slide functionality (optional)
  useEffect(() => {
    if (sliderData && sliderData.length > 1) {
      const interval = setInterval(() => {
        setActiveIndex((prevIndex) => 
          prevIndex === sliderData.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000); // Change slide every 5 seconds

      return () => clearInterval(interval);
    }
  }, [sliderData]);

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  const handleSlideClick = (item) => {

    if (item.type === 'pro') {
        navigate('/account/my-account');
      } else {
        navigate(`/audio/book-series/${item.audio_id}`);
      }

    if (onSlidePress) {
      onSlidePress(item);
    }
  };

  if (!sliderData || sliderData.length === 0) return null;

  return (
    <div className="slider-wrapper">
      <div className="slider-container">
        <div 
          className="slider-track"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {sliderData.map((item, index) => (
            <div
              key={index}
              className="slide"
              onClick={() => handleSlideClick(item)}
            >
              <div className="slide-content">
                <img 
                  src={item.image} 
                  alt={`Slide ${index + 1}`}
                  className="slide-image"
                />
                {/* {item.type === 'pro' && (
                  <div className="discount-badge">
                    <span className="discount-text">50%</span>
                    <span className="discount-subtext">Off</span>
                  </div>
                )} */}
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {sliderData.length > 1 && (
        <div className="pagination">
          {sliderData.map((_, index) => (
            <button
              key={index}
              className={`pagination-dot ${index === activeIndex ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SliderComponent;